/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_Faq_A5Inputs */

const en_simple_oto_faq_a5 = /** @type {(inputs: Simple_Oto_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Writing the plan is free. Building and publishing follow your package; human guidance starts at Rp 150 rb per review.`)
};

const id_simple_oto_faq_a5 = /** @type {(inputs: Simple_Oto_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membuat rencana gratis. Membangun dan menerbitkan mengikuti paket; pendampingan manusia mulai Rp 150 rb per tinjauan.`)
};

/**
* | output |
* | --- |
* | "Writing the plan is free. Building and publishing follow your package; human guidance starts at Rp 150 rb per review." |
*
* @param {Simple_Oto_Faq_A5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_faq_a5 = /** @type {((inputs?: Simple_Oto_Faq_A5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_Faq_A5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_faq_a5(inputs)
	return en_simple_oto_faq_a5(inputs)
});